import { isEntryMeal, isRecipeMeal, isSideableEntryMeal } from '../../../redux/mealEntry';
import type { PlannedMeal } from '../../../redux/mealPlanSlice';
import type { SideRecipe } from '../../../services/sideDish';
import type { RecipeIndexEntry } from '../../../services/unifiedRecipeService';
import { canAddDish, slotMainOf } from './slotMeals';

/**
 * The slot's main, when a side can still be added next to it: a recipe, or a
 * note / leftovers (« Porcs Sevelin BBQ » is the dinner; the salad goes with it).
 */
export function sideMainOf(slot: PlannedMeal[] | undefined): PlannedMeal | null {
  if (!slot || !canAddDish(slot)) return null;
  const main = slotMainOf(slot);
  return main && (isRecipeMeal(main) || isSideableEntryMeal(main)) ? main : null;
}

/**
 * What the side is chosen against. Leftovers are the recipe they came from. A
 * note has no recipe, so its text stands in as the title: "BBQ pork" carries no
 * starch, so potatoes are welcome; "lasagne" does, so a salad is offered.
 */
export function sideMainRecipe(
  main: PlannedMeal,
  recipeIndex: Record<string, RecipeIndexEntry>,
): SideRecipe | null {
  const entry = main.entry;
  if (!isEntryMeal(main) || !entry) return recipeIndex[main.recipeId] ?? null;
  if (entry.type === 'leftover') {
    return recipeIndex[entry.refRecipeId] ?? { id: main.id, title: '', ingredients: [] };
  }
  if (entry.type === 'note') return { id: main.id, title: entry.text, ingredients: [] };
  return null;
}
